<template>
  <el-dialog class="no-header-dialog" top="middle" :area="area" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'CloudNoHeaderDialog',
  props: {
    area: {
      type: [Array, Number],
      default: function () {
        return [480, 244];
      }
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>

</style>
<style lang="scss">
    .no-header-dialog {
        .el-dialog {
            border-radius: 4px;
        }
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            height: 100% !important;
            padding: 0;
        }
    }
</style>
